import { LOGIN_PATH } from 'config';
import { useAuth } from 'context/AuthContext';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const navigate = useNavigate();
    const { authenticated } = useAuth();
    const getToken = () => {
        const sessionToken = sessionStorage.getItem("token");
        if (sessionToken) {
            localStorage.removeItem("token");
            return sessionToken;
        }
        return localStorage.getItem("token");

    }
    const token = getToken();

    useEffect(() => {
        if (!authenticated && !token) {
            navigate(LOGIN_PATH, { replace: true });
        }
    }, [authenticated, navigate, token]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
